/* eslint-disable */
import type { SVGProps } from 'react';
import { memo } from 'react';

const RP = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    height="600"
    width="900"
    version="1.0"
    viewBox="0 0 900 600"
    {...props}
  >
    <path d="M0 0h900v600H0z" />
    <path
      style={{ fill: '#d00' }}
      d="M0 200h900v400H0z"
    />
    <path
      style={{ fill: '#ffce00' }}
      d="M0 400h900v200H0z"
    />
    <path
      d="M25.648 129.832V353.06c0 115.176 94.631 188.297 196.022 188.297 101.39 0 196.022-73.12 196.022-188.297V129.832c-67.594-14.484-128.429-19.313-196.022-19.313-67.594 0-128.428 4.829-196.022 19.313z"
      style={{
        fill: '#fff',
        stroke: '#000',
        strokeWidth: 2.8125,
        strokeLinecap: 'butt',
        strokeLinejoin: 'round',
        strokeMiterlimit: 4,
        strokeDasharray: 'none',
        strokeOpacity: 1,
      }}
      transform="matrix(.5329 0 0 .533 6.548 20.172)"
    />
    <path
      style={{
        fill: '#fff',
        stroke: '#000',
        strokeWidth: 0.9375,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeOpacity: 1,
      }}
      d="M221.086 110.248c-5.097 133.464-100.532 252.637-178.058 306.82-7.484-20.963-11.786-41.968-11.786-66.523V128.998c62.783-13.764 126.746-18.342 189.844-18.75z"
      transform="matrix(.5329 0 0 .533 6.548 20.172)"
    />
    <path
      d="M221.836 110.248c5.096 133.464 100.718 252.637 178.245 306.82 7.483-20.963 11.786-41.968 11.786-66.523V128.998c-62.784-13.764-126.933-18.342-190.031-18.75z"
      style={{
        fill: '#da121a',
        stroke: '#000',
        strokeWidth: 0.9375,
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeOpacity: 1,
      }}
      transform="matrix(.5329 0 0 .533 6.548 20.172)"
    />
    <path
      style={{
        fill: 'none',
        stroke: '#000',
        strokeWidth: 2.8125,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: 4,
        strokeDasharray: 'none',
        strokeOpacity: 1,
      }}
      d="M31.242 128.998v221.547c0 111.821 91.875 183.453 190.312 183.453 98.438 0 190.313-70.991 190.313-182.813V128.998c-65.625-14.063-124.688-18.75-190.313-18.75-65.625 0-124.687 4.687-190.312 18.75z"
      transform="matrix(.5329 0 0 .533 6.548 20.172)"
    />
    <g
      style={{ strokeWidth: 1.005_361_56 }}
      transform="matrix(.4976 0 0 .49635 -135.48 83.459)"
    >
      <circle
        r="74"
        cy="109"
        cx="640"
        style={{
          opacity: 0.99,
          fill: '#fff',
          fillOpacity: 1,
          stroke: '#000',
          strokeWidth: 3.016_084_43,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <circle
        r="59"
        cx="640"
        cy="109"
        style={{
          opacity: 0.99,
          fill: '#da121a',
          fillOpacity: 1,
          stroke: '#000',
          strokeWidth: 3.016_084_43,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <circle
        r="24"
        cy="109"
        cx="640"
        style={{
          opacity: 0.99,
          fill: '#fff',
          fillOpacity: 1,
          stroke: '#000',
          strokeWidth: 3.016_084_43,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <circle
        r="8"
        cx="640"
        cy="109"
        style={{
          opacity: 0.99,
          fill: '#da121a',
          fillOpacity: 1,
          stroke: '#000',
          strokeWidth: 3.016_084_43,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <path
        d="M633 86c-3-12-3-23.5 0-35.5 5.406-.809 8.848-.64 14 0 3 12 3 23.5 0 35.5-4.37-1.37-10.307-1.307-14 0zM633 131.958c-3 12-3 23.5 0 35.5 5.406.81 8.848.64 14 0 3-12 3-23.5 0-35.5-4.37 1.37-10.307 1.307-14 0zM656.4 91.427c8.893-8.598 18.852-14.348 30.744-17.75 3.404 4.278 4.978 7.344 7 12.125-8.892 8.598-18.851 14.348-30.744 17.75-.998-4.47-4.021-9.58-7-12.125zM616.6 114.406c-11.893 3.402-21.852 9.152-30.744 17.75 2.002 5.087 3.87 7.983 7 12.125 11.892-3.402 21.851-9.152 30.744-17.75-3.373-3.1-6.285-8.273-7-12.125zM663.4 114.406c11.893 3.402 21.852 9.152 30.744 17.75-2.002 5.087-3.87 7.983-7 12.125-11.892-3.402-21.851-9.152-30.744-17.75 3.373-3.1 6.285-8.273 7-12.125zM623.6 91.427c-8.893-8.598-18.852-14.348-30.744-17.75-3.404 4.278-4.978 7.344-7 12.125 8.892 8.598 18.851 14.348 30.744 17.75.998-4.47 4.021-9.58 7-12.125z"
        style={{
          fill: '#fff',
          stroke: '#000',
          strokeWidth: 3.016_084_43,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
      />
      <circle
        r="3"
        cy="42.5"
        cx="640"
        style={{
          opacity: 0.99,
          fill: 'none',
          fillOpacity: 1,
          stroke: '#000',
          strokeWidth: 2.010_722_88,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <circle
        cx="640"
        cy="175.5"
        r="3"
        style={{
          opacity: 0.99,
          fill: 'none',
          fillOpacity: 1,
          stroke: '#000',
          strokeWidth: 2.010_722_88,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <circle
        transform="rotate(60)"
        cx="414.397"
        cy="-566.256"
        r="3"
        style={{
          opacity: 0.99,
          fill: 'none',
          fillOpacity: 1,
          stroke: '#000',
          strokeWidth: 2.010_722_88,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <circle
        transform="rotate(60)"
        r="3"
        cy="-433.256"
        cx="414.397"
        style={{
          opacity: 0.99,
          fill: 'none',
          fillOpacity: 1,
          stroke: '#000',
          strokeWidth: 2.010_722_88,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <circle
        r="3"
        cy="-675.256"
        cx="-225.603"
        style={{
          opacity: 0.99,
          fill: 'none',
          fillOpacity: 1,
          stroke: '#000',
          strokeWidth: 2.010_722_88,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
        transform="rotate(120)"
      />
      <circle
        cx="-225.603"
        cy="-542.256"
        r="3"
        style={{
          opacity: 0.99,
          fill: 'none',
          fillOpacity: 1,
          stroke: '#000',
          strokeWidth: 2.010_722_88,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
        transform="rotate(120)"
      />
    </g>
    <path
      style={{
        fill: '#da121a',
        stroke: '#000',
        strokeWidth: 2.8125,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: 4,
        strokeDasharray: 'none',
        strokeOpacity: 1,
      }}
      d="M91.51 109.463v100.501H31.827v46.563h59.685v123.176l46.687-53.22v-69.956h45.746c9.488-12.275 16.693-27.181 19.593-46.563h-65.34v-100.5Z"
      transform="matrix(.5329 0 0 .533 6.548 20.172)"
    />
    <path
      style={{
        fill: '#000',
        stroke: 'none',
        strokeWidth: 0.9375,
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeOpacity: 1,
      }}
      d="M43.028 417.068c77.526-54.183 173.43-173.356 178.526-306.82 5.096 133.464 101 252.637 178.527 306.82-29.057 74.833-103.527 116.93-178.527 116.93-75 0-146.207-38.204-178.526-116.93z"
      transform="matrix(.5329 0 0 .533 6.548 20.172)"
    />
  </svg>
);
export default memo(RP);
